import { useCallback } from "react";
// import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getBalance, getPool } from "../../utils/contractHelpers";
import { usdt_token } from "../../utils/Enviroment";
import { create_pool } from "../../utils/Enviroment";
import { userSmartAccount } from "../../components/RecoilAtom";
import { useRecoilValue } from "recoil";
import { convertToMwei, convertFromWei } from "../../utils/helpers";
import { useEoaAccount } from "../useEoaAccount";

export const useCheckAllowance = () => {
  const { account } = useEoaAccount();
  const smartAccount = useRecoilValue(userSmartAccount);
  const web3 = useWeb3();
  let contract;

  const checkAllowance = useCallback(
    async (address) => {
      try {
        contract = await getBalance(usdt_token, web3);
        const allowance = await contract.methods
          .allowance(smartAccount, address)
          .call();
        const formattedAllowance = convertFromWei(
          String(allowance),
          "mwei"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [smartAccount, contract, web3, account]
  );


  const getAllowanceByAddress = async (tokenAddress, contractAddress) => {
    try {
      contract = await getBalance(tokenAddress, web3);
      const allowance = await contract.methods
        .allowance(smartAccount, contractAddress)
        .call();
      return allowance;
    } catch (error) {
      console.error("Check Allowance error:", error);
      throw error;
    }
  }



  const TotalLiquidityYouProvide = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userLiquidity = await contract.methods
          .lpBalances(internalAccount)
          .call();
        const formattedAllowance = convertFromWei(
          String(userLiquidity),
          "mwei"
        );
        return formattedAllowance;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  const CurrentLiquidityYouProvide = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userLiquidity = await contract.methods
          .balanceOf(usdt_token, internalAccount)
          .call();
        const formattedAllowance = convertFromWei(
          String(userLiquidity),
          "gwei"
        );
        return formattedAllowance;


      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  const UserReserved = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReserved = await contract.methods
          .reserved(usdt_token, internalAccount)
          .call();
        const returnUserReserved = userReserved
        return returnUserReserved;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );
  const UserPrviewUnreserve = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userPrviewUnreserve = await contract.methods
          .previewUnreserve(usdt_token, internalAccount)
          .call();
        const returnUserPrviewUnreserve = userPrviewUnreserve
        return returnUserPrviewUnreserve;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract, web3]
  );

  const TotalYourReward = useCallback(
    async (helper, address, internalAccount, amount) => {
      try {
        const amountConversion = convertToMwei(amount, 'gwei');
        contract = await helper(address, web3);
        const userReward = await contract.methods
          .convertToAssets(usdt_token, amountConversion)
          .call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  const TotalShare = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReward = await contract.methods.totalShares().call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  const TotalRewards = useCallback(
    async (helper, address, internalAccount) => {
      try {
        contract = await helper(address, web3);
        const userReward = await contract.methods.totalRewards().call();
        return userReward;
      } catch (error) {
        console.error("Check Allowance error:", error);
        throw error;
      }
    },
    [account, contract]
  );

  return {
    TotalRewards,
    checkAllowance,
    TotalLiquidityYouProvide,
    CurrentLiquidityYouProvide,
    TotalYourReward,
    TotalShare,
    UserReserved,
    UserPrviewUnreserve,
    getAllowanceByAddress
  };
};
